import React from 'react';
import { ShowCourierAreaData } from './ShowCourierAreaData';

export function CourierAreaConfig(): JSX.Element {
  return (
    <div>
      <ShowCourierAreaData />
    </div>
  );
}
